import React from "react";

import Image from "next/image";

import { Box, Button, Container, Typography } from "@mui/material";

import DemoImage from "../../../public/static/home/demo.png";

const HomeOverview = (props) => (
  <Box
    sx={{
      backgroundColor: "primary.main",
      position: "relative",
    }}
    {...props}
  >
    <Box
      //* Draw a background layer over base color, responsible for right bg outside of container on XL
      sx={{
        backgroundImage: "url('/static/home/overview_bg_frag2.svg')",
        backgroundSize: "contain",
        display: { xs: "none", sm: "block" },
        height: "100%",
        position: "absolute",
        right: 0,
        width: "30vw",
        zIndex: 0,
      }}
    />
    <Container
      maxWidth="lg"
      sx={{
        alignItems: "stretch",
        display: "flex",
        flexDirection: {
          xs: "column-reverse",
          sm: "row",
        },
        justifyContent: "center",
        p: 0,
        position: "relative",
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          justifyContent: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            color: "primary.contrastText",
          }}
          variant="body1"
          gutterBottom
        >
          【創作者事務所】可生產的內容包括但不限於圖畫、故事、漫畫、動畫、音樂、遊戲、虛擬YouTuber直播。
        </Typography>
        <Box py={1} />
        <Typography
          sx={{
            color: "primary.contrastText",
          }}
          variant="body1"
        >
          為企業找到最合適的創作者，讓創作者更明白企業的需求。以創意與品質抓住每一位顧客的眼球，透過數據分析精準地把資源投放在顧客的喜好之上，有效地拉近企業與顧客的距離。
        </Typography>

        <Box mb={4} />
        <Box>
          <Button
            href="/business"
            color="action"
            disableElevation
            variant="contained"
          >
            了解更多
          </Button>
        </Box>
      </Box>
      <Box
        //* Triangular visual
        sx={{
          backgroundImage: "url('/static/home/overview_bg_frag1.svg')",
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          display: { xs: "none", sm: "block" },
          width: { sm: "10%", md: "20%" },
        }}
      />
      <Box
        //* Real background extends over whole image
        sx={{
          backgroundImage: "url('/static/home/overview_bg_frag2.svg')",
          backgroundSize: "contain",
          display: "flex",
          ml: {
            xs: 0,
            // HACK render bug, may have < 1px purple bg in between, -1px to stitch correctly
            sm: "-1px",
          },
          px: { xs: 4, sm: 0 },
          py: { xs: 2, sm: 4 },
          width: { xs: "100%", sm: "150%" },
        }}
      >
        <Image alt="" src={DemoImage} objectFit="contain" />
      </Box>
    </Container>
  </Box>
);

export default HomeOverview;
